import _ from 'lodash';
import axios, { AxiosPromise } from 'axios';
import {
  normalize,
} from 'normalizr';

import { Tenant } from 'types/clients';
import requestAllPagedData from '../lib/requestAllPagedData';
import getRequestOptions, { RequestOptions } from '../lib/getRequestOptions';
import routes from '../routing';

import {
  tenantSchema,
} from '../schemas';

/**
 * Axios request used to get all tenants
 * @param {*} options
 */
export const readAllRequest = (options: RequestOptions): AxiosPromise => axios.get(
  routes.clients.readAll(),
  getRequestOptions(options),
);

/**
 * Get all tenants
*/

interface ReadAllResponse {
  data?: {
    page?: {
      number?: number;
      size?: number;
      totalElements?: number;
      totalPages?: number;
    };
    _embedded?: {
      clients?: Tenant[];
    };
  };
  [key: string]: any;
}

interface NormalizedData {
  entities?: {
    clients?: {
      [key: string]: Tenant;
    };
  };
  result?: {
    clients?: string[];
  };
  [key: string]: any;
}

export const readAll = (options = {}): AxiosPromise => requestAllPagedData(readAllRequest, options)
  .then((allResponses: ReadAllResponse[]): NormalizedData => {
    // use reduce to collect the data from all of the requests
    const nextData = allResponses.reduce((dataAccumulator: Tenant[], currentResponse: ReadAllResponse): Tenant[] => ([
      ...dataAccumulator,
      ..._.get(currentResponse, ['data', '_embedded', 'tenants'], []),
    ]), []);
    // normalize the data
    const normalizedData = normalize(
      { clients: nextData },
      { clients: [tenantSchema] },
    );
    // return the normalized data
    return normalizedData;
  });

/**
 * Get a single tenant
 */
export const read = (tenantId: string): AxiosPromise => axios.get(
  routes.clients.read(tenantId),
  getRequestOptions(),
).then((response): AxiosPromise => response.data);


export default {
  readAll,
  read,
};
